import AppointmentStatus from '@/utils/shared/constants/appointmentStatus';

export default {
  methods: {
    getAppointmentStatusColor(statusId) {
      switch (statusId) {
        case AppointmentStatus.Available:
          return `primary-1`;
        case AppointmentStatus.Coordinated:
          return `primary-16`;
        case AppointmentStatus.Confirmed:
          return `primary-15`;
        case AppointmentStatus.Cancelled_Prov:
        case AppointmentStatus.Cancelled_De:
          return `primary-10`;
        case AppointmentStatus.Completed:
          return `primary-11`;
        case AppointmentStatus.Denied:
          return `primary-18`;
        case AppointmentStatus.Extended:
          return `primary-13`;
        default: {
          return `primary-17`;
        }
      }
    },
  },
};
